"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetsmartInfinity = void 0;
const helper_1 = require("../../helper");
class NetsmartInfinity {
    parse(pastedData_, event, callbackEmit) {
        const pastedData = pastedData_.replace(/\r\n/g, "\n");
        try {
            const patientInfoRaw = (0, helper_1.substrInBetween)(pastedData, "Patient Information:", "Emergency Contact Information:");
            const nameObj = {
                firstName: (0, helper_1.substrInBetween)(patientInfoRaw, "First Name:", "M.I."),
                lastName: (0, helper_1.substrInBetween)(patientInfoRaw, "Last Name:", "Suffix:"),
            };
            const homePhone = (0, helper_1.substrInBetween)(patientInfoRaw, "Primary Phone:", "Secondary Phone:");
            const cellPhone = (0, helper_1.substrInBetween)(patientInfoRaw, "Cell Phone:", "Email:");
            const phoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(homePhone || cellPhone)
                .replace(/\s/, "")
                .replace(/[\s-()]/g, ""));
            const streetAddress = (0, helper_1.substrInBetween)(patientInfoRaw, "\nStreet:", "Suite/Apt #:");
            const city = (0, helper_1.substrInBetweenNew)(patientInfoRaw, "City:", "State:").trim();
            const state = (0, helper_1.substrInBetweenNew)(patientInfoRaw, "State:", "Zip Code:").trim();
            const zip = (0, helper_1.substrInBetweenNew)(patientInfoRaw, "Zip Code:", "Major Cross Street").trim().substring(0, 5);
            const placeName = `${streetAddress}, ${city}, ${state} ${zip}`;
            const apartmentNo = (0, helper_1.substrInBetween)(patientInfoRaw, "Suite/Apt #:", "City:");
            const addressObj = { placeName, apartmentNo };
            const dobRaw = (0, helper_1.substrInBetween)(patientInfoRaw, "Birth Date:", "Age:");
            const month = dobRaw.substring(0, 3);
            const day = dobRaw.substring(3, dobRaw.length - 4);
            const year = dobRaw.substring(dobRaw.length - 4, dobRaw.length);
            const dobWithSeparators = `${month}/${day}/${year}`;
            const dob = new Date(Date.parse(dobWithSeparators));
            const primaryInsuranceRaw = (0, helper_1.substrInBetween)(pastedData, "Primary Insurance:", "Secondary Insurance:");
            const insurance = (0, helper_1.substrInBetweenNew)(primaryInsuranceRaw, "Name:", "Street:").trim();
            const caregiverRaw = (0, helper_1.substrInBetween)(pastedData, "Emergency Contact Information:", "Hospitalization Information:");
            const caregiverName = (0, helper_1.substrInBetween)(caregiverRaw, "Emergency Contact:", "Emergency Contact Telephone No:");
            const caregiverPhoneNumberRaw = (0, helper_1.substrInBetween)(caregiverRaw, "Emergency Contact Telephone No:", "Relationship:");
            const caregiverPhoneNumber = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(caregiverPhoneNumberRaw)
                .replace(/\s/, "")
                .replace(/[\s-()]/g, ""));
            const careGiver = [];
            if (caregiverName && caregiverPhoneNumber) {
                careGiver.push({
                    name: caregiverName,
                    phoneNo: caregiverPhoneNumber,
                    countryCode: "+1",
                    sortOrder: 1,
                });
            }
            const physicianRaw = (0, helper_1.substrInBetween)(pastedData, "Physician Information:", "Certifying/F2F Physician:");
            const physicianFirstName = (0, helper_1.substrInBetween)(physicianRaw, "Physician's First Name:", "Physician's Last Name:");
            const physicianLastName = (0, helper_1.substrInBetween)(physicianRaw, "Physician's Last Name:", "PECOS Status:");
            const physicianName = `${physicianFirstName} ${physicianLastName}`;
            const physicianNoRaw = (0, helper_1.substrInBetween)(physicianRaw, "Phone:", "Fax:");
            const physicianNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(physicianNoRaw)
                .replace(/\s/, "")
                .replace(/[\s-()]/g, ""));
            const physician = [];
            if (physicianName && physicianNo) {
                physician.push({
                    name: physicianName,
                    phoneNo: physicianNo,
                    countryCode: "+1",
                    sortOrder: 1,
                });
            }
            const sendCallBackData = {
                patientInfo: Object.assign(Object.assign({}, nameObj), { address: addressObj, phoneNo,
                    dob }),
                insurance,
                info: {
                    physician,
                    pharmacy: [],
                    careGiver,
                },
            };
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error.message : error,
                errorStack: error.stack,
            });
        }
    }
}
exports.NetsmartInfinity = NetsmartInfinity;
